const CDN_HOST = 'https://nolan-space.sfo3.cdn.digitaloceanspaces.com/assets'

export {
  CDN_HOST
}
